import { useCallback, useEffect, useRef } from 'react';

interface Parameters {
    page?: string;
    location?: string;
    title?: string;
}

interface Options {
    retryTimeout?: number;
}

const DEFAULT_RETRY_TIMEOUT = 1_000;

export default function useSendGaPageView(options?: Options) {
    const retryTimeout = options?.retryTimeout ?? DEFAULT_RETRY_TIMEOUT;
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    const sendGaPageView = useCallback(
        (parameters?: Parameters) => {
            clearTimeout(timerRef.current);
            try {
                window.ga('set', {
                    page: parameters?.page ?? window.location.pathname + window.location.search,
                    location: parameters?.location ?? window.location.href,
                    title: parameters?.title ?? window.document.title
                });
                window.ga('send', 'pageview');
            } catch (error) {
                timerRef.current = setTimeout(() => sendGaPageView(), retryTimeout);
            }
        },
        [retryTimeout]
    );

    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);

    return sendGaPageView;
}
